import {request} from '@/helpers/apiClient'
import {PRODUCT_COMBO_CONFIG} from '@/utils/constants/apiConfig/productComboService'

/**
 * Creates a new product combo.
 * @param {import('@/types/productComboTypes').ProductCombo} productComboData - Product Combo payload.
 * @returns {Promise<any>} API response promise.
 */
export const saveProductCombo = productComboData => {
  return request(PRODUCT_COMBO_CONFIG.SAVE_PRODUCT_COMBO, {
    data: productComboData,
  })
}

/**
 * Checks whether a combo name is unique.
 * @param {string} name - Combo name to validate.
 * @returns {Promise<any>} API response promise.
 */
export const checkNameUnique = name => {
  return request(PRODUCT_COMBO_CONFIG.CHECK_NAME_UNIQUE(name))
}

/**
 * Get Linked Promotion with Combo Product
 * @param {string} comboProductId - Combo product ID .
 * @returns {Promise<any>} API response promise.
 */
export const getComboProductPromotion = comboProductId => {
  return request(PRODUCT_COMBO_CONFIG.GET_COMBO_PRODUCT_PROMOTION(comboProductId))
}

/**
 * Delete Combo Product
 * @param {string} comboProductId - Combo product ID .
 * @returns {Promise<any>} API response promise.
 */
export const deleteComboProduct = comboProductId => {
  return request(PRODUCT_COMBO_CONFIG.DELETE_COMBO_PRODUCT(comboProductId))
}
